import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Play, Pause } from "lucide-react";
import { Row } from "reactstrap";
import ResponsiveCarousel from "./ResponsiveCarousel";
import "./JourneySlideshow.css";

// ✅ Image imports
import img1 from "../../assets/Home/1.png";
import img2 from "../../assets/Home/2.png";
import img3 from "../../assets/Home/3.png";
import img4 from "../../assets/Home/4.png";

const slides = [
  {
    image: img1,
    title: "Catch",
    subtitle: "Sri Lankan Fishing Boats",
    description:
      "Traditional fishing boats equipped with GPS tracking capture fresh seafood from pristine waters around Sri Lanka.",
  },
  {
    image: img4,
    title: "Processing",
    subtitle: "Certified Facilities",
    description:
      "State-of-the-art processing plants maintain cold chain and hygiene standards with full documentation.",
  },
  {
    image: img2,
    title: "Courier",
    subtitle: "Temperature-Controlled Delivery",
    description:
      "Specialized refrigerated vehicles with live tracking ensure optimal conditions during transport.",
  },
  {
    image: img3,
    title: "Your Plate",
    subtitle: "Fresh & Ready",
    description:
      "Perfectly fresh seafood arrives at your table with complete journey traceability.",
  },
];

const JourneySlideshow = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  // Auto-play logic
  useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isPlaying]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  const goToSlide = (index) => setCurrentSlide(index);
  const togglePlayback = () => setIsPlaying(!isPlaying);

  return (
    <section className="journey-section bg-light">
      <div className="card rounded-3 shadow border-0 journey-card">
        <div className="hero-slideshow-container">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? "active" : ""}`}
            >
              <div className="hero-image-wrapper">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="hero-slide-img"
                />
              </div>
              <div className="hero-gradient-overlay"></div>
              <div className="hero-slide-content text-white text-center">
                <span className="badge hero-step-badge">Step {index + 1}</span>
                <h3 className="hero-slide-title">{slide.title}</h3>
                <p className="hero-slide-subtitle">{slide.subtitle}</p>
                <p className="hero-slide-description">{slide.description}</p>
              </div>
            </div>
          ))}

          {/* Navigation */}
          <button className="hero-nav-btn left" onClick={prevSlide}>
            <ChevronLeft size={20} />
          </button>
          <button className="hero-nav-btn right" onClick={nextSlide}>
            <ChevronRight size={20} />
          </button>

          {/* Play/Pause */}
          <button className="hero-play-btn" onClick={togglePlayback}>
            {isPlaying ? <Pause size={16} /> : <Play size={16} />}
          </button>

          {/* Dots */}
          <div className="hero-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`hero-dot ${index === currentSlide ? "active" : ""}`}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="hero-progress-container">
            <div
              className="hero-progress-bar"
              style={{
                width: `${((currentSlide + 1) / slides.length) * 100}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySlideshow;
